import * as React from 'react'
import {RefObject} from 'react'
import {useInView} from 'react-intersection-observer'
import {Box, Fab, Zoom} from '@mui/material'
import {Colors, FontSize, FontWeights} from '../../../../styledComponents/Constants'
import {faCommentDots} from '@fortawesome/free-regular-svg-icons'
import {RowFlexContainer} from '../../../../styledComponents/FlexComponents'
import {FontAwesomeIconWrapper} from '../../../../components/assocDirector/AssocDirectorCommon'

interface Props {
    target: RefObject<HTMLDivElement>
    onClink: (element: RefObject<HTMLDivElement>) => void
}

export const FloatingObserver: React.FC<Props> = props => {
    const {ref, inView} = useInView(({threshold: 0.5}))

    React.useEffect(() => {
        const element = props.target.current
        if (element) {
            ref(element)
        }
        return () => {
            if (element) {
                ref(null)
            }
        }
    }, [props.target, ref])

    return (
        <Zoom
            in={!inView}
            timeout={500}
            style={{
                transitionDelay: `0ms`
            }}
            unmountOnExit
        >
            <Fab
                variant={'extended'}
                disableFocusRipple
                style={{
                    color: `${Colors.Primary}`,
                    backgroundColor: `${Colors.Surface}`,
                    position: 'fixed',
                    bottom: '20px',
                    right: '15px',
                    border: `1px solid ${Colors.Primary}`,
                    width: '164px',
                    height: '50px',
                    fontSize: `${FontSize.Body}`,
                    fontWeight: `${FontWeights.Bold}`,
                    boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)'
                }}
                onClick={() => props.onClink(props.target)}
            >
                <RowFlexContainer>
                    <FontAwesomeIconWrapper
                        icon={faCommentDots}
                        iconSize={'20px'}
                        iconColor={Colors.Primary}
                    />
                    <Box ml={'5px'}>新規コメント</Box>
                </RowFlexContainer>
            </Fab>
        </Zoom>
    )
}
